import { useMutation, useQueryClient } from '@tanstack/react-query'
import { outreachApi, outreachMessagesQueryKey } from '../api'

export function useUpdateOutreachMessagesMutation(startupId: string) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (body: { msg1?: string; msg2?: string; msg3?: string }) =>
      outreachApi.updateMessages(startupId, body),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: outreachMessagesQueryKey(startupId) })
    },
  })
}
